import {
  base_colorHighlight,
  grey500,
  neutral600,
  purple200,
  text_colorTextSecondary,
  yellow800,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_md,
  font_size_4xl,
  font_size_lg,
  font_size_md,
  font_size_sm,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  .BrandPartnership-logo {
    max-height: 40px;
    height: 40px;
    object-fit: contain;

    &:not(:last-child) {
      padding-right: ${spacing(5)};
      border-right: 2px solid ${grey500};
    }
  }

  .BrandPartnership-alert {
    max-width: 790px;

    .BrandPartnership-alert-link {
      ${font_sm};
      font-family: ${font_family_weight_medium};
      text-decoration: underline;
      color: ${yellow800};
    }
  }

  .HeadingText {
    // TODO: Pair font-size and line-heights
    font-size: ${font_size_4xl};
    line-height: 36px;
    text-align: center;
  }

  .SubText {
    // TODO: Pair font-size and line-heights
    font-size: ${font_size_lg};
    line-height: 20px;
    // TODO: Figma mismatch between variables and visuals check value
    color: ${text_colorTextSecondary};
    text-align: center;
    max-width: 666px;
  }

  .PricingCards-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ${spacing(8)};
    width: 100%;

    @media (max-width: 1024px) {
      grid-template-columns: 1fr;
      justify-items: center;
    }
  }

  .PricingCard-component {
    max-width: 398px;
    min-width: 0;
    width: 100%;
    overflow-wrap: break-word;
    word-break: break-word;

    @media (max-width: 1024px) {
      order: var(--column-display-order);
    }
  }

  .PricingCard-component-pro {
    position: relative;
  }

  .PricingCard-pro-promoText {
    position: absolute;
    top: -10px;
  }

  .PricingCard-name-topText {
    color: ${neutral600};
    ${font_md}
    min-height: 36px;
  }

  .PricingCard-Avatar-enterprise {
    flex-shrink: 0;
  }

  .PricingCard-billing-toggle {
    .LabelToggle-option-label {
      &.selected {
        font-weight: bold;
      }
    }
  }

  .PricingCard-strikeout {
    color: ${text_colorTextSecondary};
    text-decoration: line-through;
    font-weight: bold;
    line-height: normal;
    font-size: 20px;
  }

  .PricingCard-price {
    &.shiny {
      background: linear-gradient(90deg, #2563eb 0%, #0f766e 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .PricingCard-price-details {
    display: flex;
    flex-direction: column;
    min-height: 36px;
  }

  .PricingCard-per-bigPrice {
    font-size: 40px;
    line-height: 48px;
  }

  .PricingCard-per-superScript {
    font-size: ${font_size_md};
    line-height: 18px;
    vertical-align: top;
  }

  .PricingCard-price-details-text {
    color: ${text_colorTextSecondary};
    font-size: ${font_size_sm};
    line-height: 16px;
  }

  .PricingCard-getStarted-heading {
    font-size: ${font_size_lg};
    line-height: 20px;
    font-weight: bold;
  }

  .PricingCard-AI-Powered {
    background-color: ${purple200};
    padding: ${spacing(2)};
    border-radius: 8px;
  }

  .PricingCard-AI-Powered-text {
    color: ${base_colorHighlight};
    font-size: ${font_size_lg};
    line-height: 20px;
  }
`
